<template>
  <div class="editorPageTable">
    <div class="editorPageTable__wrapper">
      <SimpleTable
        :data="tableContents"
        :variants="['smallHeadings', 'borderInside', 'smallPaddings', 'sameFonts']"
        blog
      />
    </div>
  </div>
</template>

<script>
import EditorTable from '~/components/Editor/EditorTable';
import SimpleTable from '~/components/SimpleTable';

export default {
  name: 'EditorPageTable',
  components: {
    EditorTable,
    SimpleTable,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      tableContents: {
        headings: [],
        content: [],
      },
    };
  },
  mounted() {
    if (typeof this.data.content !== 'undefined' && Array.isArray(this.data.content)) {
      this.tableContents.headings = this.data.content[0];
      this.tableContents.content = [...this.data.content.slice(1)];
    }
  },
};
</script>

<style lang="scss" scoped>
.editorPageTable {
  margin: 0 auto 3rem;

  @include rwd('tablet') {
    margin: 0 auto 2rem;
  }

  &__wrapper {
    @include rwd('small-tablet') {
      padding-bottom: 2rem;
      overflow: auto;

      &::-webkit-scrollbar {
        height: 5px;
      }

      &::-webkit-scrollbar-track {
        background: $cWhite;
      }

      &::-webkit-scrollbar-thumb {
        background: $cMain;
        border-radius: 5px;
      }
    }
  }
}
</style>
